module.exports = __webpack_public_path__ + "static/media/btn-ryg.ecc8100f.gif";